import buttonStyle from "./Button.module.scss";
import React, { useState } from 'react';
const { useEffect } = React;

type ButtonProps = {
    children?: string,
    variant?: "filled" | "outlined"
}

export const Button = ({ children, variant = "filled" }: ButtonProps) => {
    const [type, setType] = useState(buttonStyle.filled);

    useEffect(() => {
        if (variant === "filled") setType(buttonStyle.filled);
        else setType(buttonStyle.outlined);
    }, [variant]);

    return (
        <>
            <button
                className={`${buttonStyle.button} ${type}`} >
                {children}
            </button>
        </>
    )
}